import { LocalNotifications } from '@capacitor/local-notifications';
import App from './App.svelte';


if ('serviceWorker' in navigator) {
	window.addEventListener('load', () => {
		navigator.serviceWorker.register('./sw.js').then(
			registration => { console.log(`App started!`); },
			error => { console.error(`Service Worker registration failed: ${error}`); },
		);
	});
}

LocalNotifications.areEnabled().then(resp => {
    if (!resp.value) {
        console.log("Notifications OFF")
    } else {
        console.log("Notifications ON")
    }
})

const app = new App({
	target: document.body,
	props: {
		name: 'world'
	}
});

export default app;
